import { render } from "./WaybillTable.vue?vue&type=template&id=5e80f44d"
import script from "./WaybillTable.vue?vue&type=script&lang=js"
export * from "./WaybillTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__